@if (!isActiveSubscription) {
  <div class="alert alert-warning show text-center" role="alert">
    <div class="message">
      <span>Votre abonnement n'est plus actif.</span>
      <span>Seul l'accès en consultation est autorisé.</span>
    </div>
    @if (!isPageProfile) {
      <button mat-flat-button color="primary" routerLink="/profile" [queryParams]="subscribeParams">Activer</button>
    }
  </div>
}
